import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProfilesRoutingModule } from './profiles-routing.module';
import { Profile1Component } from './profile1/profile1.component';
import { ProfileComponent } from './profile/profile.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RegisterService } from '../register/register.service';
import { ProfileLandingComponent } from './profile-landing/profile-landing.component';
import { ProfileTabBriefComponent } from './tabs/profile-tab-brief/profile-tab-brief.component';
import { ProfileTabShieldComponent } from './tabs/profile-tab-shield/profile-tab-shield.component';
import { ProfileTabPortfolioComponent } from './tabs/profile-tab-portfolio/profile-tab-portfolio.component';
import { ProfileTabTestimonialsComponent } from './tabs/profile-tab-testimonials/profile-tab-testimonials.component';
import { ProfileTabReviewsComponent } from './tabs/profile-tab-reviews/profile-tab-reviews.component';
import { ProfileTabAboutComponent } from './tabs/profile-tab-about/profile-tab-about.component';
import { ProfileTabBusinessComponent } from './tabs/profile-tab-business/profile-tab-business.component';


@NgModule({
  declarations: [
    ProfileComponent,
    Profile1Component,
    ProfileLandingComponent,
    ProfileTabBriefComponent,
    ProfileTabShieldComponent,
    ProfileTabPortfolioComponent,
    ProfileTabTestimonialsComponent,
    ProfileTabReviewsComponent,
    ProfileTabAboutComponent,
    ProfileTabBusinessComponent,
  ],
  imports: [
    CommonModule,
    ProfilesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [
    RegisterService,
  ]
})
export class ProfilesModule { }
